import type { MinQuantityRequirement } from './types';

export const noRequirement = {
  enforced: false,
  requiredTotal: 0,
  requiredQuantity: 1,
} as const satisfies MinQuantityRequirement;
